
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import DetailProduct from './DetailProduct';
import BurritosScreens from './burritos'

function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [mexicam, setMexican] = useState(false);

    const [molcajete, setMolcajete] = useState (false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [entradas, setEntradas] = useState(false);
    const [guacamole, setGuacamole] = useState (false);
    const [showBurritos, setShowBurritos] = useState(false);

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);



    
          useEffect(() => {
                menus.map((item) => {

                    if (item.id === 371) {
                        setMexican(item.menus);
                    }
                    if (item.id === 373) {
                        setEntradas(item.menus);
                    }
                    
                });
          }, [menus]);
    
     useEffect(() => {
    if (mexicam) {
      mexicam.map((item) => {
        if (item.id === 3103) {
          setMolcajete(item);
        }
      });
    }
     }, [mexicam]);
    
     useEffect(() => {
    if (entradas) {
      entradas.map((item) => {
        if (item.id === 3133) {
          setGuacamole(item);
        }
      });
    }
  }, [entradas]);
    
        
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={() => {
            setdishs(drinks)
            setShowListProduct(true)
        }}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                    <p
                        style={{
                        color: 'white',
                        textAlign: 'center',
                        fontSize: 30,
                        fontFamily: 'Roadstore',
                        }}>
                        {langEng ? ' OUR FAVORITES' : 'Nuestros Favoritos'}
                    </p>

                    <div
                        onClick={() =>
                        {
                            setDataDish({ dish: molcajete, alldish: mexicam, currentDish: molcajete })
                            setShowDetailProduct(true)
                        
                        }
                        }>
                        <img
                            src={require('./assets/molcajete.png')}
                            style={{
                                marginTop: 40,
                                width: '100%',
                                height: 275,
                                objectFit: 'contain',
                                borderRadius: 40,
                                alignSelf: 'center',
                                marginBottom: 40,
                            }}
                        />
                    </div>

                    <div
                        style={{
                        
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            display: 'flex',
                        paddingInline: 20
                    }}>
                    <div
                    style={{width: '50%', marginTop: 10}}
                    onClick={() =>
                    {
                        setDataDish({ dish: guacamole, alldish: entradas, currentDish: guacamole })
                            setShowDetailProduct(true)
                    }
                    }>
                    <img
                        src={require('./assets/chips.png')}
                        style={{
                        width: '100%',
                        height: 250,
                        objectFit: 'contain',
                        alignSelf: 'center',
                        }}
                    />
                    </div>
                    <div
                            onClick={() => {
                                setShowBurritos(true)
                    }}
                    style={{width: '50%'}}>
                    <img
                        src={require('./assets/burrito.png')}
                        style={{
                        width: '100%',
                        height: 280,
                        objectFit: 'contain',
                        marginLeft: 27,
                            alignSelf: 'center',
                        marginTop: 12
                        }}
                    />
                    </div>
                </div>

                   
                </div>

                 {showBurritos && <BurritosScreens setshowCategories={setShowBurritos} />}

                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}
            </LayoutContent>
        </div>
    );
}
export default Index;